import React from 'react';
import Grid from '@mui/material/Grid'
import './Footer.css';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const linksFooter = [
    {
        to: 'https://inlinetracking.com/privacy-statement/',
        name: 'Privacy Statement'
    },
    {
        to: 'https://inlinetracking.com/terms-of-use/',
        name: 'Terms of Use'
    },
    {
        to: 'https://inlinetracking.com/contact-us/',
        name: 'Contact Us'
    },
    {
        to: 'https://mfiles.inlinepallets.com.au/inlinepallets/default.asp',
        name: 'Login'
    },

];

export default function Footer() {

    return (
        <div className='footer'>
            <Box>
                <Grid container className='footer1-item' sx={{ bgcolor: 'rgb(60,60,60)' }}>
                    {linksFooter.map(link => (
                        <Grid item xs={'auto'} key={link.name} className='footer1-item-list'>
                            <Typography variant='footer1-line' href={link.to} component={Link}>
                                {link.name}
                            </Typography>
                        </Grid>
                    )
                    )}
                </Grid>
                <Grid container className='footer1-item' sx={{ bgcolor: 'rgb(30, 30, 30)' }}>
                    <Typography className='footer2-line'>
                        Site designed by Coalmine Canary | Copyright 2021 INLINE Tracking
                    </Typography>
                </Grid>
            </Box>
        </div>
    );
}